import {ChangeDetectorRef, Inject, Optional, Pipe, PipeTransform} from '@angular/core';
import {SearchAgreementsRepresentation} from '@aztrix/sdk';
import {BehaviorSubject} from 'rxjs';

import {LANGUAGE_OVERRIDE, TranslatePipe, TranslateService} from '@aztrix/translate';

@Pipe({
  name: 'agreementConfirmationLabel',
  pure: false,
})
export class agreementConfirmationLabelPipe implements PipeTransform {
  private _translatePipe: TranslatePipe;
  constructor(
    translate: TranslateService,
    changeDetector: ChangeDetectorRef,
    @Optional()
    @Inject(LANGUAGE_OVERRIDE)
    languageOverride$?: BehaviorSubject<string | undefined>
  ) {
    this._translatePipe = new TranslatePipe(translate, changeDetector, languageOverride$);
  }

  transform(
    confirmation: SearchAgreementsRepresentation.AgreementConfirmationEnum | undefined
  ): string {
    let translateKey = '';
    switch (confirmation) {
      case SearchAgreementsRepresentation.AgreementConfirmationEnum.CONFIRMED:
        translateKey = 'agreement.status.confirmed';
        break;
      case SearchAgreementsRepresentation.AgreementConfirmationEnum.UNCONFIRMED:
        translateKey = 'agreement.status.not-confirmed';
        break;
      default:
        break;
    }
    return this._translatePipe.transform(translateKey);
  }
}
